import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const SendAudioComponent = ({ port }) => {
  const [audioFile, setAudioFile] = useState(null);
  const [ampValue, setAmpValue] = useState(5000);
  const [status, setStatus] = useState(0);
  const ip = document.getElementById("ip").value;
  //const amp = document.getElementById("amp").value;
  const score = `
    set_option("outdevice=net:${ip}:${port}")
    rtsetparams(44100,2,1024)
    rtinput("${audioFile}")
    MIX(0, 0, DUR(), ${ampValue} * 0.0001, 0, 1)
    `;
  return (
    <div style={{ maxWidth: "300px" }}>
      {audioFile ? (
        <div>
          <div>
            <Status status={status} /> {port}
          </div>
          <pre style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>
            {audioFile}
          </pre>
          <div style={{ textAlign: "center" }}>
            <div>
              <Form.Label>amp(0.0-1.0)</Form.Label>
              <Form.Range
                min={0}
                max={10000}
                value={ampValue}
                onChange={(e) => {
                  setAmpValue(e.currentTarget.valueAsNumber);
                }}
                step={1}
              ></Form.Range>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={() => {
                if (status === -1) return;
                setStatus(-1);
                let formData = new FormData();
                formData.append(
                  "file",
                  new Blob([score], { type: "text/plain" }),
                  "file.sco"
                );
                fetch("http://127.0.0.1:8080/uploadFile", {
                  method: "POST",
                  body: formData,
                }).finally(() => setStatus(1));
              }}
            >
              Send
            </Button>
          </div>
        </div>
      ) : (
        <>
          <div>
            <Button
              onClick={(e) => {
                fetch("http://127.0.0.1:8080/selectFile")
                  .then((r) => r.text())
                  .then((r) => {
                    setAudioFile(r);
                  });
                // setAudioFile("some/pathsome/pathsome/pathsome/pathsome/pathsome/pathsome/path.wav");
              }}
            >
              Select Audio File
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

const Status = ({ status }) => {
  return (
    <span
      style={{
        width: "15px",
        height: "15px",
        display: "inline-block",
        margin: "0 1px",
        border: "1px solid black",
        borderRadius: "99px",
        backgroundColor:
          status === 1 ? "green" : status === 0 ? "lightgrey" : "red",
      }}
    ></span>
  );
};

export default SendAudioComponent;
